<div class="search--vehicle">
	<label class="required" title="* Required" *ngIf="label && required">{{label}}</label>
	<label *ngIf="label && !required">{{label}}</label>
	<omnisearch [context]="1" [placeholder]="placeholder" (onSelected)="vehicleSelected($event)" [title]="'Vehicle Search'" (onSearchCompleted)="searchCompleted($event)" (onSearchStringUsed)="getSearchString($event)" *ngIf="!vehicle && !vehicleId"></omnisearch>

	<div class="search--omni" [ngClass]="{disabled : readOnly}" *ngIf="vehicle && !searchOnly">
		<ul>
			<li>
				<ul class="search--omni__list">
					<li><b>VIN:</b>&nbsp;{{vehicle.vin}}</li>
					<li><b>Year/Make/Model:</b>&nbsp;{{vehicle.modelYear}} {{vehicle.makeDisplayValue}} {{vehicle.modelDisplayValue}}</li>
					<li *ngIf="vehicle.ownerName"><b>Owner:</b> {{vehicle.ownerName}}</li>
					<li *ngIf="vehicle.lienHolderName"><b>LienHolder:</b> {{vehicle.lienHolderName}}</li>
				</ul>
			</li>
			<li class="search--omni__remove">
				<a class="icon--remove" title="Remove" href="javascript:void(0)" (click)="removeVehicle()"></a>
			</li>
		</ul>
	</div>

	<div class="mvd_alert__validation" *ngIf="validationMessage != ''">
        <div class="mvd_alert__rule">{{validationMessage}}</div>
	</div>
	<button class="icon--add btn--default" type="button" *ngIf="!vehicle && hasSearched && !searchOnly" (click)="addVehicle()">Add New Vehicle</button>
</div>